enum TextButtonTheme {
  Navy = "Navy",
  Primary = "Primary",
}

export default TextButtonTheme;
